import { render } from "./F944.vue?vue&type=template&id=71e22479"
import script from "./F944.vue?vue&type=script&lang=js"
export * from "./F944.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__